import './notices.css';
import React, { useEffect, useState } from "react";
import { FaEdit, FaTimes   } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import Swal from "sweetalert2";
import axios from "axios";
import { useForm } from "react-hook-form";

function Notices() {

  const [advertisement, setAdvertisement] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentAdvertisement, setCurrentAdvertisement] = useState({
    "text_es": "",
    "text_en": "",
    "desc_es": "",
    "title_es": "",
    "desc_en": "",
    "id_advertisement": "",
    "title_en": "",
    "type": "advertisement"
  });
  const { handleSubmit, register, reset, setValue, formState: {errors, isValid} } = useForm();

  useEffect(() => {
    getAdvertisements();
  }, [updateTrigger]);

  React.useEffect(() => {
    Object.keys(currentAdvertisement).forEach(key => {
      setValue(key, currentAdvertisement[key]);
    });
  }, [currentAdvertisement, setValue]);

  const getAdvertisements = async () => {
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`;
    try {
      const response = await axios.get(url, {
        headers: {
          authorization: process.env.REACT_APP_PUBLIC_KEY,
        }
      });

      const onlyAdvertisements = response.data.data.filter(
        item => item.type === "advertisement"
      );

      setAdvertisement(onlyAdvertisements);
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  const limitText = (text) => {
    const limit = 100;
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  }

  const statusModal = (status, id_code) => {
    if(status === "create") {
      setCreateModal(true);
    } else if (status === 'update') {
      setUpdateModal(true);
    } else {
      setCreateModal(false);
      setUpdateModal(false);
      reset();
    }
  }

  const setterCurrentAdvertisement = (data) => {
    setCurrentAdvertisement({
      "text_es": "",
      "text_en": "",
      "desc_es": data.desc_es,
      "title_es": data.title_es,
      "desc_en": data.desc_en,
      "id_advertisement": data.id_advertisement,
      "title_en": data.title_en,
      "type": "advertisement"
    });
  }

  const createStation = async (data) => {
    const body = {
      ...data,
      type: "advertisement",
      text_es: "",
      text_en: ""
    }
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/create`;

    try {
      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

      Swal.fire("¡Creado!", "creado exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();

      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al crear el anuncio",
        text: "No se ha creado ningún anuncio."
      });
      statusModal();
    }
  }

  const updateStation = async (data) => {
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/update/${data.id_advertisement}`;

    try {
      const respose = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

      Swal.fire("¡Exitoso!", "Editado exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();
      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al editar el anuncio",
        text: "No se ha editado ningún anuncio."
      });
      statusModal();
    }
  }

  const deleteAdvertisement = async (code) => {
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/${code}`;
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "esta estacion sera eliminada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if(result.isConfirmed) {
        await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        });
  
        Swal.fire("¡Eliminado!", "Eliminado Exitosamente.", "success");
      }
      setUpdateTrigger(!updateTrigger);
      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al eliminar el anuncio",
        text: "No se ha eliminado ningún anuncio."
      });
      statusModal();
    }
  }

  return (
    <>
      <div className="headbands-container">

        <div className="btn-create-content-adv">
          <button className="btnn" onClick={() => statusModal('create')}>
            Crear Aviso
          </button>
        </div>

        <div className="headbands-headers">
          <p className="title">Texto</p>
          <p className="actions">Acciones</p>
        </div>

        {advertisement.map((item) => (
          <div className="headbands-item">
            <p>{limitText(item.desc_es)}</p>
            <div className="btns-content">
              <button className="edit-btn" onClick={() => {
                setterCurrentAdvertisement(item);
                statusModal('update', item.id_advertisement);
              }}>
                <FaEdit />
              </button>
              <button className="delete-btn" onClick={() => deleteAdvertisement(item.id_advertisement)}>
                <FaTimes />
              </button>
            </div>
          </div>
        ))}

      </div>

      {/* =====================================================
      CREATE Modal
      ===================================================== */}
      {
        createModal && (
          <div className="station-modal">
            <div className="bg-modal-station" onClick={statusModal}></div>

            <section>
              <div className="header-station">
                <div></div>
                <h4>Crear Estacion</h4>
                <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                  <FaXmark />
                </div>
              </div>

              <div className="body-station">
                  <form onSubmit={handleSubmit(createStation)}>
                    <h4 className="lng-text">Español</h4>

                    <div className="input-container-stations">
                      <label>Titulo:</label>
                      <input className="bold-text" id="title_es" type="text" placeholder="" {...register("title_es")} autoComplete="off" />
                    </div>

                    <div className="input-container-stations">
                      <label>Descripción: <span className="required">*</span></label>
                      <input id="desc_es" type="text" placeholder="" {...register("desc_es", {required: true})} autoComplete="off"/>
                    </div>

                    <h4 className="lng-text">Ingles</h4>

                    <div className="input-container-stations">
                      <label>Titulo:</label>
                      <input className="bold-text" id="title_en" type="text" placeholder="" {...register("title_en")} autoComplete="off" />
                    </div>

                    <div className="input-container-stations">
                      <label>Descripción: <span className="required">*</span></label>
                      <input id="desc_en" type="text" placeholder="" {...register("desc_en", {required: true})} autoComplete="off"/>
                    </div>
                    
                    <div className="btn-container-stations">
                      <button type="submit">Enviar</button>
                      <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                    </div>

                  </form>
              </div>
            </section>
          </div>
        )
      }

      {/* =====================================================
      UPDATE Station Modal
      ===================================================== */}
      {updateModal && (
        <div className="station-modal">
          <div className="bg-modal-station" onClick={statusModal}></div>

          <section>
            <div className="header-station">
              <div></div>
              <h4>Actualizar Estacion</h4>
              <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                <FaXmark />
              </div>
            </div>

            <div className="body-station">
                <form onSubmit={handleSubmit(updateStation)}>

                  <h4 className="lng-text">Español</h4>

                  <div className="input-container-stations">
                    <label>Titulo:</label>
                    <input className="bold-text" id="title_es" type="text" placeholder="" {...register("title_es")} autoComplete="off" />
                  </div>

                  <div className="input-container-stations">
                    <label>Descripción: <span className="required">*</span></label>
                    <input id="desc_es" type="text" placeholder="" {...register("desc_es", {required: true})} autoComplete="off"/>
                  </div>

                  <h4 className="lng-text">Ingles</h4>

                  <div className="input-container-stations">
                    <label>Titulo:</label>
                    <input className="bold-text" id="title_en" type="text" placeholder="" {...register("title_en")} autoComplete="off" />
                  </div>

                  <div className="input-container-stations">
                    <label>Descripción: <span className="required">*</span></label>
                    <input id="desc_en" type="text" placeholder="" {...register("desc_en", {required: true})} autoComplete="off"/>
                  </div>
                  
                  <div className="btn-container-stations">
                    <button type="submit">Enviar</button>
                    <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                  </div>

                </form>
            </div>
          </section>
        </div>
      )}
    </>
  );

}

export default Notices;